export const ContactGroupTypes = {
  CONTACT: 'CONTACT',
  FAVORITE: 'FAVORITE',
  MARKETING: 'MARKETING',
  APPEND: 'APPEND',
  INVESTOR: 'INVESTOR',
};

export const REDACTED_CONTACT_KEYS_MAP ={ 
  "undisclosed": true, 
  "redacted" : true, 
  "removed": true, 
  "restricted": true, 
  "n/a": true, 
  "na": true, 
  "none": true,		
  "not available": true, 
  "not provided": true, 
  "withheld": true, 
  "anonymous": true, 
  "confidential": true,
	"redacted upon request": true, 
  "not available from the data source": true, 
  "record owner": true,
};

export default ContactGroupTypes;
